import React, { Component } from "react";
import { compose, graphql } from "react-apollo";
import * as QueryString from "query-string";
import { connect } from "react-redux";
import {
  Grid,
  Typography,
  TextField,
  Fab,
  Button,
  Switch,
  FormControlLabel,
  IconButton,
  Icon,
  Hidden,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { Add, Remove, HelpOutline } from "@material-ui/icons";
import { CREATE_DISH, UPDATE_DISH } from "../../graphql/mutations/dish";
import { DISH_TYPES } from "../../config/constants";
import FileUpload from "../../components/FileUpload";
import ImageView from "../../components/Image";
import {
  fontColor,
  parentContainer,
  primaryColor,
  webFont
} from "../../config/theme";
import Header from "../Header";
import Footer from "../Footer/FooterLoggedIn";
import { CUISINES } from "../../graphql/queries/dishes";
import { NotificationManager } from "react-notifications";
import ReactAutocomplete from "react-autocomplete";
import style from "../../containers/ChefSetup/style";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import InputField from "../Field";
import InputError from "../Field";
import {GET_CHEF_DETAILS} from "../../graphql/queries/chef";
import Breadcrumbs from "../Breadcrumbs";

const DishSchema = Yup.object().shape({
  dishName: Yup.string().required("Dish Name is Required !"),
  minDinerSize: Yup.number().min(4, "Minimum diner size is 4"),
  approxPrepTime: Yup.number()
    .min(1, "Please Enter Vaild value!"),
  description: Yup.string().required("Description is Required !")
});

class ADish extends Component {
  state = {
    errors: false,
    dishName: "",
    dishNameError: "",
    selectedDishTypes: [],
    description: "",
    descriptionError: "",
    cuisines: [],
    cuisine: "",
    selected: [],
    ingredients: [],
    ingredient: "",
    ingredientsError: "",
    equipmentNeeded: [],
    minDinerSize: 1,
    approxIngredientsCost: 0,
    approxPrepTime: 10,
    isDraft: true,
    loading: false,
    equipment: "",
    routeData: {},
    minPrice: 50,
    minPriceError: "",
    media: [],
    id: null,
    cuisinesError: false,
    cuisinesErrorTime: false,
    showApproxCostDialog: false,
    showApproxTimeDialog: false,
    cuisineToBeDeleted: ""
  };

  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
  }

  addMedia = mediaData => {
    const { media } = this.state;

    if (mediaData) {
      media.push(mediaData);
    }

    this.setState({ media });
  };

  removeMedia = file => {
    const { media } = this.state;
    const removed = media.filter(f => {
      return file.url !== f.url;
    });
    this.setState({ media: removed });
  };

  handleChange = e => {
    const { name, value } = e.target;

    switch (name) {
      default:
        return;

      case "dishName":
        if (value === null || value === "") {
          this.setState({dishNameError: "Please enter a dish name"});
        }
        else { this.setState({ dishName: value, dishNameError: "" }); }
        break;

      case "description":
        if (value === null || value === "") {
          this.setState({ descriptionError: "Please enter dish description." });
        }
        else { this.setState({ description: value, descriptionError: "" }); }
        break;

      case "minDinerSize":
        this.setState({ minDinerSize: Number(value) });
        break;
    }

    const {dishNameError, selected} = this.state;
    if (dishNameError.trim().length <= 0 || selected.length <= 0) {
      this.setState({ errors: true });
    } else {
      this.setState({ errors: false });
    }
  };

  handleSubmit = async (values, {setErrors, resetForm}) => {
    let {
      approxIngredientsCost,
      minPrice,
      selectedDishTypes,
      equipmentNeeded,
      ingredients,
      isDraft,
      id,
      media,
      selected,
      cuisines,
    } = this.state;

    let {
      approxPrepTime,
      description,
      dishName,
      minDinerSize,
    } = values;

    if (selected.length <= 0) {
      NotificationManager.error('Cuisines are mandatory', 'Add Dish');
      return;
    }

    if (minDinerSize < 1) {
      NotificationManager.error("Minimum diner size should be 1 or more", "Add Dish");
      return;
    }

    if (!isDraft) {
      let isDraftErrors = false;

      if (dishName === '' || !dishName) {
        isDraftErrors = true;
      }

      if (media.length <= 0) {
        isDraftErrors = true;
      }

      if (description.length <= 0) {
        isDraftErrors = true;
      }

      if(selected.length <= 0) {
        isDraftErrors = true;
      }

      if (ingredients.length <= 0) {
        isDraftErrors = true;
      }

      if (minPrice <=0) {
        isDraftErrors = true;
      }

      if (this.state.approxPrepTime === 0) {
        this.setState({ cuisinesErrorTime: true });
        isDraftErrors = true;
      } else {
        this.setState({ cuisinesErrorTime: false });
      }

      if (selected.length === 0) {
        this.setState({ cuisinesError: true });
        isDraftErrors=true;
      } else {
        this.setState({ cuisinesError: false });
      }

      if (isDraftErrors) {
        NotificationManager.error("Please fill in all mandatory fields", "Add Dish");
        return;
      }
    }

    if (media.length === 0) {
      isDraft=true;
    }


    const { addDish, updateDish } = this.props;
    const isUpdate = id && id.length;
    const payload = {
      dish: {
        chefId: this.props.userId,
        name: dishName,
        description: description.replace(/(?:\r\n|\r|\n)/g, '<br />'),
        cuisines: selected,
        approxIngredientsCost: approxIngredientsCost,
        approxPrepTime: approxPrepTime,
        dishTypes: selectedDishTypes,
        ingredients: ingredients,
        minDinerSize: minDinerSize,
        minPrice: minPrice,
        media: media.map(m => {
          const { type, url, size, appType } = m;
          return { url, type, size, appType };
        }),
        isDraft,
        equipmentNeeded: equipmentNeeded
      }
    };
    if (isUpdate) {
      if (!payload.isDraft) {
        if (payload.dish.media.length === 0 || payload.dish.name === "" || payload.dish.minDinerSize < 1 || payload.dish.minPrice < 1) {
          payload.isDraft = true;
        }
      }
      payload.dish = { ...payload.dish, id };
    }


    this.setState({ loading: true });
    try {
      const DishRes = isUpdate
        ? await updateDish({ variables: payload })
        : await addDish({ variables: payload });
      if (DishRes) {
        this.setState({ loading: false, routeData: DishRes }, () => {
          this.returnBack();
        });
      }
    } catch (e) {
      let errorObj = JSON.parse(JSON.stringify(e));
      console.log(errorObj);
      this.setState({ loading: false });
      if (errorObj.graphQLErrors) {
        errorObj.graphQLErrors.map(error => {
          NotificationManager.error(error.message, "Add Dish");
        });
      }
    }
  };

  componentDidMount() {
    const { isChef } = this.props;

    const { location } = this.props;
    const { state } = location;
    if (!isChef) {
      this.props.history.push("/home/dashboard");
    }

    if (this.props.location && this.props.location.state) {
      const { state } = this.props.location;
      if (state.dish) {
        const {
          name,
          minPrice,
          minDinerSize,
          media,
          isDraft,
          ingredients,
          equipmentNeeded,
          dishTypes,
          description,
          cuisines,
          id,
          approxPrepTime
        } = state.dish;

        this.setState({
          dishName: name,
          selectedDishTypes: dishTypes,
          description: description,
          selected: cuisines,
          cuisines,
          ingredients,
          equipmentNeeded,
          minDinerSize,
          approxIngredientsCost: 1,
          isDraft,
          minPrice,
          approxPrepTime: approxPrepTime? approxPrepTime: 0,
          media,
          id
        });
      }
    }
  }

  returnBack = () => {
    const { location } = this.props;
    if (location && location.search) {
      const { state } = location;
      const params = QueryString.parse(location.search);
      if (params) {
        const { destination } = params;
        if (destination === "chef-steps") {
          this.props.history.push("/home/become-chef?step=8&path=portfolio", {
            ...state,
            step: 8
          });
        } else if (destination === "portfolio") {
          this.props.history.push("/home/dashboard", {
            newDish: this.state.routeData
          });
        }
      }
    } else {
      this.props.history.push("/home/dashboard", {
        newDish: this.state.routeData
      });
    }
  };

  componentWillUnmount() {
    const { isChef } = this.props;
    this.setState({
      errors: false,
      dishName: "",
      dishNameError: "",
      selectedDishTypes: [],
      description: "",
      descriptionError: "",
      cuisines: [],
      cuisine: "",
      selected: [],
      ingredients: [],
      ingredient: "",
      ingredientsError: "",
      equipmentNeeded: [],
      minDinerSize: 1,
      approxIngredientsCost: 0,
      approxPrepTime: 10,
      isDraft: true,
      loading: false,
      equipment: "",
      routeData: {},
      minPrice: 50,
      minPriceError: "",
      media: [],
      id: null,
      cuisinesError: false,
      cuisinesErrorTime: false,
      showApproxCostDialog: false,
      showApproxTimeDialog: false
    });
    if (!isChef) {
      this.props.history.push("/home/dashboard");
    } else {
      this.returnBack();
    }
  }

  incrementPrice = () => {
    const { minPrice } = this.state;
    const updatedPrice = minPrice + 5;
    this.setState({ minPrice: updatedPrice });
  };

  decrementPrice = () => {
    const { minPrice } = this.state;

    if (minPrice - 5 <= 0) {
      NotificationManager.error('Price cannot be 0 or less', 'Add Dish');
      return;
    }
    if (minPrice >= 5) {
      const updatedPrice = minPrice - 5;
      this.setState({ minPrice: updatedPrice });
    }
  };

  incrementTime = () => {
    const { approxPrepTime } = this.state;
    const updatedPrice = approxPrepTime + 5;
    this.setState({ approxPrepTime: updatedPrice });
  };

  decrementTime = () => {
    const { approxPrepTime } = this.state;

    if (approxPrepTime -5 <= 0) {
      NotificationManager.error('Time cannot be 0 or less', 'Add Dish');
    }

    if (approxPrepTime >= 5) {
      const updatedPrice = approxPrepTime - 5;
      this.setState({ approxPrepTime: updatedPrice });
    }
  };

  handleDishTypes = dType => {
    const { selectedDishTypes } = this.state;

    if (selectedDishTypes.length > 0) {
      const index = selectedDishTypes.findIndex(item => item === dType.name);

      if (index > -1) {
        this.setState({
          selectedDishTypes: selectedDishTypes.filter((val, index) => {
            return val !== dType.name;
          })
        });
      } else {
        const updatedDishTypes = this.state.selectedDishTypes;
        updatedDishTypes.push(dType.name);
        this.setState({ selectedDishTypes: updatedDishTypes });
      }
    } else {
      const updatedDishTypes = this.state.selectedDishTypes;
      updatedDishTypes.push(dType.name);
      this.setState({ selectedDishTypes: updatedDishTypes });
    }
  };

  handleCuisineChange = value => {
    this.setState({ cuisine: value });
  };

  addCuisine = () => {
    const { selected, cuisine } = this.state;
    const list = this.props.cuisinesList.cuisines;

    if(cuisine.trim().length<=0)
      return;

    if (!list.find(c => c.toLowerCase() === cuisine.toLowerCase())) {
      NotificationManager.error("For any new cuisines to be added in the list, please make a feature request in Feedback under Account", "Cuisines");
      return;
    }

    if (selected.find(c => c === cuisine)) {
      NotificationManager.error(cuisine + " is already selected", "Add Dish");
      return;
    }
    selected.push(cuisine);
    this.setState({ selected, cuisine: "" });
  };

  addIngridient = () => {
    let { ingredients, ingredient } = this.state;

    if(ingredient.trim().length<=0)
      return;

    if (ingredients.find(c => c === ingredient)) {
      NotificationManager.error(
        ingredient + " is already selected",
        "Add Dish"
      );
      return;
    }

    ingredient = this.capitalize(ingredient);

    ingredients.push(ingredient);
    this.setState({ ingredients, ingredient: "" });
  };

  addEqupment = () => {
    let { equipmentNeeded, equipment } = this.state;

    if(equipment.trim().length<=0)
      return;

    if (equipmentNeeded.find(i => i === equipment)) {
      NotificationManager.error(
        equipment + " is already selected",
        "Add Dish"
      );
      return;
    }

    equipment = this.capitalize(equipment);

    equipmentNeeded.push(equipment);
    this.setState({ equipmentNeeded, equipment: "" });
  };

  onKeyDown = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13 && keyEvent.target.nodeName !== 'TEXTAREA') {
      keyEvent.preventDefault();
    }
  };

  render() {
    const { selectedDishTypes, id, media } = this.state;

    const isUpdate = id && id.length;

    const generateDishTypBtn = DISH_TYPES.map(dishType => {
      const index = selectedDishTypes.findIndex(
        item => item === dishType.name || item === dishType.display
      );
      const isSelected = index > -1 ? true : false;

      return (
        <Grid item key={dishType.name} style={{position: 'relative', marginRight: 24}}>
          <Button
            data-test-id={"dishtype-id"}
            size="small"
            variant={isSelected ? "contained" : "outlined"}
            style={isSelected ? styles.btnDishTypeSelected : styles.btnDishType}
            onClick={() => this.handleDishTypes(dishType)}
          >
            {this.capitalize(dishType.display)}
          </Button>
        </Grid>
      );
    });

    let dishMedia = media.length > 0
        ? media.filter(m => {
            return m.size === "MEDIUM";
          })
        : [];

    if (dishMedia.length === 0 && media.length > 0) {
      dishMedia = media;
    }

    dishMedia = dishMedia.filter(item => item.size === 'MEDIUM');

    return (
      <div style={parentContainer}>
        <Grid container>
          <Grid item xs={12}>
            <Header {...this.props} />
          </Grid>

          {this.state.loading && <LinearProgress color="primary" />}

          <Grid container className="add-dishes-container">
            <Grid item xs={12} style={{ marginTop: 30 }}>
              <Breadcrumbs childRoutes={[
                {
                  display: 'Dishes',
                  link: '#'
                },
                {
                  display: isUpdate ? 'Edit Dish' : 'Add Dish',
                  link: 'home/add-dish'
                }
              ]} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" style={styles.header}>
                Add dishes
              </Typography>
            </Grid>

            <Formik
              initialValues={{
                dishName: this.state.dishName || "",
                description: this.state.description ? this.state.description.replace(/<br\s*[\/]?>/gi, "\n") : "",
                minDinerSize: this.state.minDinerSize || 0,
                approxPrepTime: this.state.approxPrepTime || 0,
                minPrice: this.state.minPrice || 0
              }}
              validate={values => {
                let errors = {};
                if (values.dishName.trim().length<=0) {
                  errors.dishName = 'Required';
                }

                return errors;
              }}
              enableReinitialize
              onSubmit={this.handleSubmit}
            >
              {({ errors, touched, values }) => (
                <Form
                  onKeyDown={this.onKeyDown}
                  className="add-dish-form"
                  style={{ width: "100%", marginTop: 8 }}
                  onChange={vals => {
                    if (vals.target.name === "dishName") {
                      this.setState({ dishName: vals.target.value });
                    }
                    if (vals.target.name === "description") {
                      this.setState({ description: vals.target.value });
                    }
                  }}
                >
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      className="custom-input"
                    >
                      <InputField
                        name={"dishName"}
                        placeholder={"Name of the dish*"}
                        error={errors.dishName && touched.dishName}
                        errorMessage={errors.dishName}
                        type={"text"}
                        hideLabel={true}
                        style={styles.setFont}
                        onTextChange={dishName => {
                          this.setState({ dishName });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justify="flex-start"
                    style={{ marginTop: 20 }}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          style={styles.label}
                          gutterBottom={true}
                        >
                          Add photos*
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item xs={12}>
                      <Grid container className="add-dish-button">
                        {!!dishMedia &&
                          !!dishMedia.length &&
                          dishMedia.map((image, i) => (
                            <ImageView
                              key={i + "image"}
                              url={image.url}
                              page="add-dish"
                              onDelete={() => {
                                this.removeMedia(image);
                              }}
                            />
                          ))}
                        {this.state.media.length < 3 && (
                          <FileUpload
                            onUploadStart={() =>
                              this.setState({ loading: true })
                            }
                            onSuccess={res => {
                              const { data } = res;
                              this.setState({ loading: false });
                              this.addMedia(data);
                            }}
                            onError={err => console.log(err)}
                            fileType="IMAGE"
                            page={"add-dish"}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container style={{ marginTop: 20 }}>
                    <Grid item xs={12}>
                      <Grid item xs={12} style={{ marginTop: 20 }}>
                        <ReactAutocomplete
                          items={this.props.cuisinesList.cuisines || []}
                          shouldItemRender={(item, value) =>
                            item.toLowerCase().indexOf(value.toLowerCase()) >
                              -1 && value.length > 0
                          }
                          wrapperStyle={{ width: "100%", marginBottom: 60 }}
                          getItemValue={item => item}
                          renderItem={(item, highlighted) => (
                            <div
                              key={new Date().getMilliseconds() + item}
                              style={style.suggenstionBox}
                            >
                              <p style={style.suggestionText}> {item}</p>
                            </div>
                          )}
                          value={this.state.cuisine}
                          menuStyle={{
                            zIndex: 100,
                            maxHeight: 100,
                            overflow: "auto"
                          }}
                          onChange={e =>
                            this.handleCuisineChange(e.target.value)
                          }
                          onSelect={value => this.setState({ cuisine: value })}
                          renderInput={props => {
                            return (
                              <div className="group">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between"
                                  }}
                                >
                                  <Typography
                                    variant="h5"
                                    align="left"
                                    style={{margin: 0, display: 'flex', alignItems: 'center', fontWeight: 500, fontFamily: webFont}}
                                  >
                                    Cuisine*
                                  </Typography>

                                  <IconButton
                                    className="add-icon"
                                    data-test-id={"addcuisbtn"}
                                    color="default"
                                    aria-label="Add"
                                    size="small"
                                    style={{ top: this.state.cuisine.length <= 0 ? 47 : 70 }}
                                    disabled={this.state.cuisine.length <= 0}
                                    onClick={() => this.addCuisine()}
                                  >
                                    <Icon
                                      color={
                                        this.state.cuisine.length > 0
                                          ? "primary"
                                          : "action"
                                      }
                                      style={{fontSize: 32,}}
                                    >
                                      add_circle
                                    </Icon>
                                  </IconButton>
                                </div>
                                {this.state.cuisine.length > 0 && <div className="add-dish-cuisine-message">
                                  <span>Click on plus icon to add cuisine</span>
                                </div>}

                                <input
                                    data-test-id={"adddishcuis"}
                                  className="mat-input"
                                  placeholder="Enter cuisine"

                                  type="text"
                                  {...props}
                                />

                                <span className="highlight" />

                                <span
                                  className="bar"
                                  style={{ width: "100%" }}
                                />
                              </div>
                            );
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Grid container spacing={8} style={{ marginLeft:0}}>
                          {this.state.selected.map((item, index) => (
                            <Button
                              // fullWidth
                              key={index + item}
                              variant="outlined"
                              color="primary"
                              style={style.cuisineButton}
                              disableRipple={true}
                              onClick={()=>{
                                this.state.selected.splice(index,1);
                                this.setState({selected:this.state.selected});
                              }}
                            >
                              {item}
                            </Button>
                          ))}
                        </Grid>
                      </Grid>
                      <InputError
                        type={"error"}
                        error={this.state.cuisinesError}
                        errorMessage={"Cusines Are Required !."}
                        style={styles.setFont}
                      />
                    </Grid>
                  </Grid>

                  <Grid container style={{ marginTop: 40 }}>
                    <Grid item xs={12}>
                      <Typography
                        variant="h6"
                        style={styles.label}
                        gutterBottom={true}
                      >
                        Dish types
                      </Typography>

                      <Grid container direction="row">
                        {generateDishTypBtn}
                      </Grid>

                      <Grid className="textarea-col" container style={{ marginTop: 20 }}>
                        <Grid item xs={12}>
                          <Typography
                            variant="h6"
                            style={styles.label2}
                            gutterBottom={true}
                          >
                            Description*
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <InputField
                            name={"description"}
                            placeholder={"Add description here"}
                            error={errors.description && touched.description}
                            errorMessage={errors.description}
                            type={"textarea"}
                            multiline
                            rows="12"
                            hideLabel={true}
                            style={styles.setFont}
                          />
                        </Grid>
                      </Grid>

                      <Grid container style={{ marginTop: 20 }}>
                        <Typography
                          variant="h6"
                          style={styles.label2}
                          gutterBottom={true}
                        >
                          Ingredients*
                        </Typography>

                        <Grid item md={12} xs={12}>
                          <TextField
                          inputProps={{ 'data-test-id': 'ingred-id' }}
                            fullWidth={true}
                            type={"text"}
                            value={this.state.ingredient}
                            style={styles.setFont}
                            onChange={evt =>
                              this.setState({ ingredient: evt.target.value })
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="Add ingredients"
                                    disabled={this.state.ingredient.length <= 0}
                                    onClick={this.addIngridient}
                                    style={{ top: '-3px', padding: 0, right: 0 }}
                                  >
                                    <Icon
                                    data-test-id={"addingredbtn"}
                                      color={
                                        this.state.ingredient.length > 0
                                          ? "primary"
                                          : "action"
                                      }
                                      style={{fontSize: 32}}
                                    >
                                      add_circle
                                    </Icon >
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={8} style={{ marginTop: 20 , marginLeft:0}}>
                            {this.state.ingredients.map((item, index) => (
                              <Button
                                // fullWidth
                                key={index + item}
                                variant="outlined"
                                color="primary"
                                style={{
                                  ...style.cuisineButton,
                                  ...styles.setFont
                                }}
                                onClick={()=>{
                                  this.state.ingredients.splice(index,1);
                                  this.setState({ingredients:this.state.ingredients});
                                }}
                                disableRipple={true}
                              >
                                {item.toUpperCase()}
                              </Button>
                            ))}
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container style={{ marginTop: 40 }}>
                        <div className="text-icon-col">
                          <Typography
                            variant="h6"
                            style={styles.label}
                            gutterBottom={true}
                          >
                            Approx. cost to diner*
                          </Typography>
                          <span className="question-icon" onClick={() => this.setState({ showApproxCostDialog: true })}>
                            <HelpOutline />
                          </span>
                        </div>

                        <Grid container style={{alignItems: 'center'}}>
                          <Grid
                            item>
                            <Fab
                              data-test-id={"remcost"}
                              color="primary"
                              size="small"
                              onClick={this.decrementPrice}
                              style={styles.calcBtn}
                            >
                              <Remove />
                            </Fab>
                          </Grid>
                          <Grid
                           data-test-id={"minprice-id"}
                          item style={{margin: '0 24px'}}>
                            <Typography variant="h6" style={styles.label3}>
                              ${this.state.minPrice}
                            </Typography>
                          </Grid>
                          <Grid

                          item>
                            <Fab
                            data-test-id={"addprice"}
                              color="primary"
                              size="small"
                              onClick={this.incrementPrice}
                              style={styles.calcBtn}
                            >
                              <Add />
                            </Fab>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container style={{ marginTop: 40 }}>
                        <div className="text-icon-col">
                          <Grid item xs={11}>
                            <Typography
                              variant="h6"
                              style={styles.label}
                              gutterBottom={true}
                            >
                              Approx. prep time*
                            </Typography>
                          </Grid>
                          <span className="question-icon" onClick={() => this.setState({ showApproxTimeDialog: true })}>
                            <HelpOutline />
                          </span>
                        </div>

                        <Grid container>
                          <Grid

                          item>
                            <Fab
                             data-test-id={"remtime"}
                              color="primary"
                              size="small"
                              onClick={this.decrementTime}
                              style={styles.calcBtn}
                            >
                              <Remove />
                            </Fab>
                          </Grid>
                          <Grid
                            data-test-id={"preptime"}
                           item style={{margin: '0 24px'}}>
                            <Typography variant="h6" style={styles.label3}>
                              {this.state.approxPrepTime} : 00
                            </Typography>
                          </Grid>
                          <Grid

                          item>
                            <Fab
                             data-test-id={"addtime"}
                              color="primary"
                              size="small"
                              onClick={this.incrementTime}
                              style={styles.calcBtn}
                            >
                              <Add />
                            </Fab>
                          </Grid>
                        </Grid>
                        <InputError
                          type={"error"}
                          error={
                            errors.approxPrepTime && values.approxPrepTime <= 0
                          }
                          errorMessage={"Approx. prep time is required."}
                          style={styles.setFont}
                        />
                      </Grid>

                      <Grid container style={{ marginTop: 40 }}>
                        <Typography
                          variant="h6"
                          style={styles.label}
                          gutterBottom={true}
                        >
                          Serves a minimum of*
                        </Typography>
                        <Grid item xs={12} className="custom-input">
                          <InputField
                            name={"minDinerSize"}
                            placeholder={"Enter minimum diner size *"}
                            error={errors.minDinerSize && touched.minDinerSize}
                            errorMessage={errors.minDinerSize}
                            type={"text"}
                            inputType={"number"}
                            hideLabel={true}
                            style={styles.setFont}
                          />
                        </Grid>
                      </Grid>

                      <Grid container style={{ marginTop: 40 }}>
                        <Typography
                          variant="h6"
                          style={styles.label}
                          gutterBottom={true}
                        >
                          Equipments needed
                        </Typography>
                        <Grid item md={12} xs={12}>
                          <TextField
                          inputProps={{ 'data-test-id': 'addequip-id' }}
                            fullWidth={true}
                            type={"text"}
                            value={this.state.equipment}
                            style={styles.setFont}
                            onChange={evt =>
                              this.setState({ equipment: evt.target.value })
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="Add equipment"
                                    disabled={this.state.equipment.length <= 0}
                                    onClick={this.addEqupment}
                                    style={{ top: '-3px', padding: 0, right: 0 }}
                                  >
                                    <Icon
                                    data-test-id={"addequipbtn"}
                                      color={
                                        this.state.equipment.length > 0
                                          ? "primary"
                                          : "action"
                                      }
                                      style={{fontSize: 32}}
                                    >
                                      add_circle
                                    </Icon>
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={8} style={{ marginTop: 20, marginLeft:0}}>
                            {this.state.equipmentNeeded.map((item, index) => (
                              <Button
                                // fullWidth
                                key={index + item}
                                variant="outlined"
                                color="primary"
                                style={{
                                  ...style.cuisineButton,
                                  ...styles.setFont
                                }}
                                disableRipple={true}
                                onClick={()=>{
                                  this.state.equipmentNeeded.splice(index,1);
                                  this.setState({equipmentNeeded:this.state.equipmentNeeded});
                                }}
                              >
                                {item.toUpperCase()}
                              </Button>
                            ))}
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container style={{ marginTop: 20 }}>
                        <Grid item xs={12} style={{ display: "flex" }}>
                          <p
                            style={{
                              fontSize: 24,
                              fontFamily: webFont,
                              fontWeight: 500
                            }}
                          >
                            Live
                          </p>
                          <FormControlLabel
                            control={
                              <Switch
                              data-test-id={"liveswitch"}
                                checked={!this.state.isDraft}
                                onChange={() => {
                                  if (this.state.isDraft && this.state.media && !!this.state.media.length && this.state.media.length > 0 && this.state.ingredients.length > 0) {
                                    this.setState({
                                      isDraft: false
                                    })
                                  } else {
                                    this.setState({
                                      isDraft: true
                                    })

                                    if (this.state.ingredients.length <= 0 || this.state.media.length <= 0 || errors.dishName || errors.description || errors.minDinerSize || this.state.approxPrepTime <= 0)
                                      NotificationManager.error("Mandatory fields are needed to make it live", "Add dish");
                                  }

                                  const { chefDetails : { chef } } = this.props;
                                  if (!chef.profilePic) {
                                    this.setState({
                                      isDraft: true
                                    })
                                    NotificationManager.error("You need to add profile picture in order to make dishes live", "Add dish");
                                  }
                                } }
                              />
                            }
                            label=""
                          />
                        </Grid>
                      </Grid>

                      <Grid
                       data-test-id={"createbtn"}
                        container
                        alignItems="center"
                        justify="center"
                        direction="row"
                      >
                        <Hidden smUp>
                          <Grid item xs={2} />
                          <Grid

                          item xs={8}>
                            <Fab
                              data-test-id={"dishsubmitbtn"}
                              variant={"extended"}
                              disabled={this.state.loading}
                              type={"submit"}
                              style={
                                this.state.loading
                                  ? style.submitButtonDisabled
                                  : style.submitButton
                              }
                            >
                              {isUpdate ? "Update" : "Create"}
                            </Fab>
                          </Grid>
                        </Hidden>
                        <Hidden xsDown>
                          <Grid item md={12} style={{ textAlign: "center" }}>
                            <Fab
                             data-test-id={"dishsubbtn"}
                              variant={"extended"}
                              disabled={this.state.loading}
                              onClick={() =>
                                console.log(JSON.stringify(errors))
                              }
                              type={"submit"}
                              style={
                                this.state.loading
                                  ? style.createButtonDisabled
                                  : style.createButton
                              }
                            >
                              {isUpdate ? "Update" : "Save"}
                            </Fab>
                          </Grid>
                        </Hidden>
                      </Grid>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </Grid>

          <Dialog
            open={this.state.showApproxCostDialog}
            onClose={() => this.setState({ showApproxCostDialog: false })}
            aria-labelledby="alert-dialog-approx-cost"
            aria-describedby="alert-dialog-approx-cost-to-diner"
          >
            <DialogTitle>
              Approx. cost to diner
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                This approximate cost to diner applies to "Serves a minimum of (diners)" you specify below.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ showApproxCostDialog: false })}>
                Ok
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={this.state.showApproxTimeDialog}
            onClose={() => this.setState({ showApproxTimeDialog: false })}
            aria-labelledby="alert-dialog-approx-cost"
            aria-describedby="alert-dialog-approx-cost-to-diner"
          >
            <DialogTitle>
              Approx. prep time
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Approximate time to prepare dish.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ showApproxTimeDialog: false })}>
                Ok
              </Button>
            </DialogActions>
          </Dialog>

          <Footer />
        </Grid>
      </div>
    );
  }
}

const AddDishWithData = compose(
  graphql(CREATE_DISH, { name: "addDish" }),
  graphql(UPDATE_DISH, { name: "updateDish" }),
  graphql(GET_CHEF_DETAILS, {
    name: 'chefDetails',
    options: props => ({
      variables: {
        id: props.userId
      }
    })
  }),
  graphql(CUISINES, {
    name: "cuisinesList",
    options: props => ({
      variables: {
        country: "US"
      }
    })
  })
)(ADish);
const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef
  };
};

const AddDish = connect(mapStateToProps)(AddDishWithData);

export default AddDish;

const styles = {
  label: {
    fontFamily: webFont,
    fontSize: 24,
    fontWeight: 500,
    margin: '0 0 24px',
  },
  label2: {
    fontFamily: webFont,
    fontSize: 24,
    fontWeight: 500,
    margin: '0 0 16px',
  },
  label3: {
    fontFamily: webFont,
    fontSize: 20,
    fontWeight: 500,
    margin: 0,
  },
  header: {
    fontFamily: webFont,
    fontSize: 32,
    fontWeight: 500,
    margin: '40px 0',
  },

  setFont: {
    fontFamily: webFont
  },
  heavy: {
    fontWeight: 800
  },
  littleHeavy: {
    fontWeight: 600
  },
  addMediaBox: {
    maxWidth: 154,
    height: 154,
    borderWidth: 1,
    borderColor: primaryColor,
    borderStyle: "solid",
    marginRight: 5
  },
  btnPlus: {
    marginTop: 55
  },
  btnPlusDishes: {
    marginLeft: 150
  },
  btnIcon: {
    color: fontColor
  },
  btnDishType: {
    borderRadius: 20,
    borderColor: primaryColor,
    maxWidth: 140,
    width: 140,
    minWidth: 40,
    minHeight: 40,
    marginBottom: 24,
    borderWidth: 1,
    borderStyle: "solid",
    color: primaryColor,
    backgroundColor: "#fff",
    display: 'flex',
    fontSize: 15,
    boxShadow: 'none',
    fontFamily: 'Poppins',
    textTransform: 'none'
  },
  btnDishTypeSelected: {
    borderRadius: 20,
    borderColor: primaryColor,
    borderWidth: 1,
    borderStyle: "solid",
    color: fontColor,
    backgroundColor: primaryColor,
    maxWidth: 140,
    width: 140,
    minWidth: 40,
    minHeight: 40,
    marginBottom: 24,
    display: 'flex',
    fontSize: 15,
    boxShadow: 'none',
    fontFamily: 'Poppins',
    textTransform: 'none'
  },
  dishTypeDet: {
    fontSize: 10,
    color: '#ff8000',
  },
  calcBtn: {
    boxShadow: 'none',
    width: 30,
    height: 30,
    color: '#ff8000',
    background: 'transparent',
    border: '1px solid #ff8000',
    minHeight: 30,
  }
};
